import React from "react";

import { twMerge } from "tailwind-merge";

type Props = {
  className?: string;
  children?: any;
  name: string;
  activeTab: string;
  onClick: (_name: string) => void;
};

const ToggleButton = ({
  className,
  children,
  activeTab,
  name,
  onClick,
}: Props) => {
  const isActive = activeTab === name;

  return (
    <>
      <button
        className={twMerge(
          "border-none rounded-full text-[13px]",
          "px-[16px] py-[6px]",
          className,
          isActive ? "bg-smart-blue" : "bg-[#ccc]",
          isActive && "text-white"
        )}
        onClick={() => onClick(name)}
      >
        {children}
      </button>
    </>
  );
};

export default ToggleButton;
